import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import Login from './pages/Login.jsx';
import Pending from './pages/Pending.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Devices from './pages/Devices.jsx';
import Etechlog from './pages/Etechlog.jsx';
import CrossCheck from './pages/CrossCheck.jsx';
import NoShows from './pages/NoShows.jsx';
import Settings from './pages/Settings.jsx';
import Users from './pages/Users.jsx';
import Stats from './pages/Stats.jsx';
import Profile from './pages/Profile.jsx';
import Bookings from './pages/Bookings.jsx';
import Calendar from './pages/Calendar.jsx';
import Layout from './components/Layout.jsx';

function CenteredSpinner() {
  return (
    <div className="flex h-screen items-center justify-center text-cathay-700">Loading…</div>
  );
}

function RequireAuth({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <CenteredSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  // JIT default-deny: authenticated centrally but no app role yet.
  if (user.role === 'none') return <Navigate to="/pending" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  const { user, loading } = useAuth();
  if (loading) return <CenteredSpinner />;
  return (
    <Routes>
      {/* Login always renders itself — it decides internally whether to
          bounce an authenticated visitor, so the signed-out / error states
          survive a frame of stale user state (see Login.jsx). */}
      <Route path="/login" element={<Login />} />
      <Route
        path="/pending"
        element={
          !user ? <Navigate to="/login" replace />
          : user.role === 'none' ? <Pending />
          : <Navigate to="/" replace />
        }
      />
      <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/calendar" element={<RequireAuth><Calendar /></RequireAuth>} />
      <Route path="/bookings" element={<RequireAuth><Bookings /></RequireAuth>} />
      <Route path="/cross-check" element={<RequireAuth><CrossCheck /></RequireAuth>} />
      <Route path="/no-shows" element={<RequireAuth><NoShows /></RequireAuth>} />
      <Route path="/devices" element={<RequireAuth><Devices /></RequireAuth>} />
      <Route path="/etechlog" element={<RequireAuth><Etechlog /></RequireAuth>} />
      <Route path="/users" element={<RequireAuth><Users /></RequireAuth>} />
      <Route path="/stats" element={<RequireAuth><Stats /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
      <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
